export default __webpack_public_path__ + "static/media/banner-new-mobile.846f870d.jpg";